import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNavigationStore = defineStore('navigation', () => {
  const requestedDay = ref<number | undefined>(undefined)
  const requestedViewMode = ref<string | undefined>(undefined)
  // Monotonic counter — bump on every setViewMode call so watchers fire even
  // when the requested mode matches the previous one (e.g. tapping the
  // header logo twice in a row both times requesting 'main'). Plain ref
  // watching wouldn't re-fire for same-value writes.
  const viewModeNonce = ref(0)
  const reloadTrigger = ref(0)

  const setDay = (day: number) => { requestedDay.value = day }
  const setViewMode = (mode: string) => {
    requestedViewMode.value = mode
    viewModeNonce.value++
  }
  const triggerReload = () => { reloadTrigger.value++ }

  return {
    requestedDay, requestedViewMode, viewModeNonce, reloadTrigger,
    setDay, setViewMode, triggerReload,
  }
})
